import { CompanyDTO } from "@shaarp/common";

/**
 * Module-level store for tracking which company key-contacts dialog is open.
 * The dialog is rendered by KeyContactsDialog (outside the table) so it is
 * never affected by table cell remounts. Lives in its own module so React
 * Fast Refresh can keep working on the components that consume it.
 */
export const keyContactsDialogStore = {
  company: null as CompanyDTO | null,
  listeners: new Set<() => void>(),
  getSnapshot(): CompanyDTO | null {
    return keyContactsDialogStore.company;
  },
  subscribe(listener: () => void): () => void {
    keyContactsDialogStore.listeners.add(listener);
    return () => keyContactsDialogStore.listeners.delete(listener);
  },
  open(company: CompanyDTO): void {
    keyContactsDialogStore.company = company;
    keyContactsDialogStore.listeners.forEach((l) => l());
  },
  close(): void {
    keyContactsDialogStore.company = null;
    keyContactsDialogStore.listeners.forEach((l) => l());
  },
};
